import './EmptyProductSearchResult.less';
import emptyStateImage from '../../../img/empty-state.svg';
import { useTranslation } from '../../../hooks/useTranslation';

type EmptyProductSearchResultProps = {
    searchText?: string;
    isInvalidSearch?: boolean;
};

const EmptyProductSearchResult = ({
    searchText,
    isInvalidSearch = false
}: EmptyProductSearchResultProps) => {
    const { t } = useTranslation();
    return (
        <div class="bri-EmptyProductSearchResult">
            <img src={emptyStateImage} />
            {searchText && (
                <div class="bri-DisplayFont">
                    {t('PRODUCT_SEARCH_EMPTY_RESULT_TITLE')}
                </div>
            )}
            <div class="bri-TitleBoldFont">
                {searchText
                    ? `"${searchText}"`
                    : t('PRODUCT_SEARCH_FILTER_EMPTY_RESULT_TITLE')}
            </div>
            <div class="bri-BodyFont bri-EmptyProductSearchResult-subheader">
                {searchText
                    ? isInvalidSearch
                        ? t('PRODUCT_SEARCH_INVALID_SEARCH_SUBTITLE')
                        : t('PRODUCT_SEARCH_EMPTY_RESULT_SUBTITLE')
                    : t('PRODUCT_SEARCH_FILTER_EMPTY_RESULT_SUBTITLE')}
            </div>
        </div>
    );
};

export default EmptyProductSearchResult;
